/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoogleSearchConsoleReportFactData } from './GoogleSearchConsoleReportFactData';
import {
    GoogleSearchConsoleReportFactDataFromJSON,
    GoogleSearchConsoleReportFactDataFromJSONTyped,
    GoogleSearchConsoleReportFactDataToJSON,
    GoogleSearchConsoleReportFactDataToJSONTyped,
} from './GoogleSearchConsoleReportFactData';

/**
 * 
 * @export
 * @interface GoogleSearchConsoleReportData
 */
export interface GoogleSearchConsoleReportData {
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSearchConsoleReportData
     */
    available?: boolean;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleReportData
     */
    recipe?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleReportData
     */
    siteUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleReportData
     */
    completeness?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GoogleSearchConsoleReportData
     */
    truncated?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleReportData
     */
    fetchedAt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleSearchConsoleReportData
     */
    publishedAt?: string | null;
    /**
     * 
     * @type {Array<GoogleSearchConsoleReportFactData>}
     * @memberof GoogleSearchConsoleReportData
     */
    rows?: Array<GoogleSearchConsoleReportFactData>;
}

/**
 * Check if a given object implements the GoogleSearchConsoleReportData interface.
 */
export function instanceOfGoogleSearchConsoleReportData(value: object): value is GoogleSearchConsoleReportData {
    return true;
}

export function GoogleSearchConsoleReportDataFromJSON(json: any): GoogleSearchConsoleReportData {
    return GoogleSearchConsoleReportDataFromJSONTyped(json, false);
}

export function GoogleSearchConsoleReportDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleSearchConsoleReportData {
    if (json == null) {
        return json;
    }
    return {
        
        'available': json['available'] == null ? undefined : json['available'],
        'recipe': json['recipe'] == null ? undefined : json['recipe'],
        'siteUrl': json['siteUrl'] == null ? undefined : json['siteUrl'],
        'completeness': json['completeness'] === undefined ? undefined : json['completeness'] === null ? null : json['completeness'],
        'truncated': json['truncated'] === undefined ? undefined : json['truncated'] === null ? null : json['truncated'],
        'fetchedAt': json['fetchedAt'] === undefined ? undefined : json['fetchedAt'] === null ? null : json['fetchedAt'],
        'publishedAt': json['publishedAt'] === undefined ? undefined : json['publishedAt'] === null ? null : json['publishedAt'],
        'rows': json['rows'] == null ? undefined : ((json['rows'] as Array<any>).map(GoogleSearchConsoleReportFactDataFromJSON)),
    };
}

export function GoogleSearchConsoleReportDataToJSON(json: any): GoogleSearchConsoleReportData {
    return GoogleSearchConsoleReportDataToJSONTyped(json, false);
}

export function GoogleSearchConsoleReportDataToJSONTyped(value?: GoogleSearchConsoleReportData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'available': value['available'],
        'recipe': value['recipe'],
        'siteUrl': value['siteUrl'],
        'completeness': value['completeness'],
        'truncated': value['truncated'],
        'fetchedAt': value['fetchedAt'],
        'publishedAt': value['publishedAt'],
        'rows': value['rows'] == null ? undefined : ((value['rows'] as Array<any>).map(GoogleSearchConsoleReportFactDataToJSON)),
    };
}

